import scrollTo from "../../../utils/scrollTo/scrollTo";
import { fireLooksButtonClickScrollTracking } from "../../../analytics/looks/looksButtonClickScroll";

export const handleLooksScroll = ({ event, looksProducts }) => {
  fireLooksButtonClickScrollTracking({ products: looksProducts });
  scrollTo("buyTheLookTitle", event);
};
